// import getSidebarItem from './load-more-elements/sidebar-item';

function generateTabs(sectionName, {
    isLoadMore = false,
    display = 'block',
    data = [],
    initialTab = 'all'
} = {}) {
    // debugger;
    const tabs = document.querySelector(`.tabs-${sectionName}`)?.children;
    if (!tabs) {
      return
    }
    const sidebarInner = isLoadMore && document.querySelector(`.${sectionName} .sidebar__inner`);
    const tabsContentList = document.querySelectorAll(`.${sectionName}-tab-content`);
    // const loadMoreBtn = isLoadMore && sidebarInner.querySelector(`button`);
    let selectedTabContent = {
        tabContentName: initialTab,
        tabContentEl: document.querySelector(`.${sectionName}-tab-content[data-tabData='${initialTab}']`)
    };
    Array.from(tabs).forEach((itm) => {
        itm.onclick = (e) => {
            const tabEl = e.target;
            const tabContent = document.querySelector(`.${sectionName}-tab-content[data-tabData='${tabEl.dataset.tab}']`);
            openTab(tabEl, tabsContentList, tabContent, selectedTabContent);
        };
    });

    // if (loadMoreBtn) {
    //   loadMoreBtn.onclick = () => {
    //     data.forEach((itm) => {
    //       const item = getSidebarItem(itm);
    //       selectedTabContent.tabContentEl.append(item);
    //     });
    //
    //     if (selectedTabContent.tabContentEl.offsetHeight >= 1330 && selectedTabContent.tabContentEl.style.overflowY !== 'scroll') {
    //       selectedTabContent.tabContentEl.style.maxHeight = '1330px';
    //       selectedTabContent.tabContentEl.style.overflowY = 'scroll';
    //       sidebarInner.style.paddingRight = '6px';
    //       sidebarInner.classList.add('sidebar__scrollable');
    //     }
    //     selectedTabContent.tabContentEl.scroll({
    //       top: selectedTabContent.tabContentEl.scrollHeight - 2500,
    //       behavior: "smooth"
    //     })
    //   }
    // }

    function openTab(tabEl, tabsContentList, tabContent, selectedTabContent) {

        Array.from(tabsContentList).forEach((itm, i) => {
            itm.style.display = "none";
            tabs[i].classList.remove('tabs__item_active')
        });
        tabEl.classList.toggle('tabs__item_active');
        tabContent.style.display = display;
        selectedTabContent.tabContentName = tabEl.dataset.tab;
        selectedTabContent.tabContentEl = tabContent;
    }

}

export default generateTabs;
